import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes, FaWhatsapp, FaPlus, FaMinus, FaTrash, FaShoppingBag } from 'react-icons/fa';
import { useCart } from '../../context/CartContext';
import styles from './Cart.module.css';

const Cart = () => {
    const {
        cartItems,
        removeFromCart,
        updateQuantity,
        clearCart,
        getCartTotal,
        isCartOpen,
        closeCart,
    } = useCart();

    const handleWhatsAppOrder = () => {
        if (cartItems.length === 0) return;

        let message = '🛒 *Order from Bahariya Farm*\n\n';

        cartItems.forEach((item, index) => {
            message += `${index + 1}. ${item.name}\n`;
            message += `   Size: ${item.size}\n`;
            message += `   Quantity: ${item.quantity}\n`;
            message += `   Price: ₹${item.price} x ${item.quantity} = ₹${item.price * item.quantity}\n\n`;
        });

        message += `*Total: ₹${getCartTotal()}*\n\n`;
        message += 'Please confirm my order. Thank you!';

        const whatsappNumber = '919265297081'; // Replace with actual WhatsApp number
        const encodedMessage = encodeURIComponent(message);
        window.open(`https://wa.me/${whatsappNumber}?text=${encodedMessage}`, '_blank');
    };

    return (
        <AnimatePresence>
            {isCartOpen && (
                <>
                    {/* Backdrop */}
                    <motion.div
                        className={styles.backdrop}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={closeCart}
                    />

                    {/* Cart Sidebar */}
                    <motion.div
                        className={styles.cartSidebar}
                        initial={{ x: '100%' }}
                        animate={{ x: 0 }}
                        exit={{ x: '100%' }}
                        transition={{ type: 'spring', damping: 25, stiffness: 200 }}
                    >
                        {/* Header */}
                        <div className={styles.cartHeader}>
                            <h2>
                                <FaShoppingBag /> Your Cart
                            </h2>
                            <button className={styles.closeBtn} onClick={closeCart}>
                                <FaTimes />
                            </button>
                        </div>

                        {/* Cart Items */}
                        <div className={styles.cartBody}>
                            {cartItems.length === 0 ? (
                                <div className={styles.emptyCart}>
                                    <div className={styles.emptyIcon}>🛒</div>
                                    <h3>Your cart is empty</h3>
                                    <p>Add some delicious Bilona Ghee to get started!</p>
                                </div>
                            ) : (
                                <div className={styles.cartItems}>
                                    {cartItems.map((item) => (
                                        <motion.div
                                            key={item.id}
                                            className={styles.cartItem}
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, x: -100 }}
                                        >
                                            <img src={item.images[0]} alt={item.name} className={styles.itemImage} />

                                            <div className={styles.itemDetails}>
                                                <h4>{item.name}</h4>
                                                <p className={styles.itemSize}>{item.size}</p>
                                                <p className={styles.itemPrice}>₹{item.price}</p>
                                            </div>

                                            <div className={styles.itemActions}>
                                                <div className={styles.quantityControl}>
                                                    <button
                                                        onClick={() => updateQuantity(item.id, item.quantity - 1)}
                                                        className={styles.quantityBtn}
                                                    >
                                                        <FaMinus />
                                                    </button>
                                                    <span className={styles.quantity}>{item.quantity}</span>
                                                    <button
                                                        onClick={() => updateQuantity(item.id, item.quantity + 1)}
                                                        className={styles.quantityBtn}
                                                    >
                                                        <FaPlus />
                                                    </button>
                                                </div>

                                                <button
                                                    onClick={() => removeFromCart(item.id)}
                                                    className={styles.removeBtn}
                                                >
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        </motion.div>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Footer */}
                        {cartItems.length > 0 && (
                            <div className={styles.cartFooter}>
                                <div className={styles.totalSection}>
                                    <span className={styles.totalLabel}>Total:</span>
                                    <span className={styles.totalAmount}>₹{getCartTotal()}</span>
                                </div>

                                <button
                                    className={styles.whatsappBtn}
                                    onClick={handleWhatsAppOrder}
                                >
                                    <FaWhatsapp /> Order via WhatsApp
                                </button>

                                <button
                                    className={styles.clearBtn}
                                    onClick={clearCart}
                                >
                                    Clear Cart
                                </button>
                            </div>
                        )}
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default Cart;
